var MobileDetect = require('mobile-detect');
const md = new MobileDetect(navigator.userAgent);

module.exports = require('backbone').View.extend({
  tagName: 'iframe',
  attributes: {
    allowfullscreen: 'allowfullscreen',
    frameBorder: '0'
  },

  initialize(o) {
    const model = this.model;
    model.view = this;
    this.conf = o.config || {};
    this.pfx = this.conf.stylePrefix || '';
  },

  updateDim(w, h, b = undefined, l = undefined, r = undefined, t = undefined) {
    const $el = this.$el;
    const posStyle = {
      ...(l || l === 0 ? { left: l + 'px' } : {}),
      ...(r || r === 0 ? { right: r + 'px' } : {}),
      ...(b || b === 0 ? { bottom: b + 'px' } : {}),
      ...(t || t === 0 ? { top: t + 'px' } : {})
    };
    $el.css(posStyle);
    if ($el[0]) {
      $el[0].style.setProperty('height', h, 'important');
      $el[0].style.setProperty('width', w, 'important');
    }
  },

  setFullScreen() {
    const $el = this.$el;
    if (
      this.conf.chat_box_position === 7 ||
      this.conf.chat_box_position === 4
    ) {
      this.$el.css({
        height: '100%',
        width: '100%',
        'border-radius': '0px',
        left: '0px',
        bottom: '0px'
      });
    } else {
      this.$el.css({
        height: '100%',
        width: '100%',
        'border-radius': '0px',
        right: '0px',
        bottom: '0px'
      });
    }
    $el[0].style.setProperty('top', '0px', 'important');
  },

  resetFullScreen() {
    this.$el.css({ top: 'auto' });
  },

  getDocument() {
    return this.el.contentDocument;
  },

  getBody() {
    const doc = this.getDocument();
    return doc.body;
  },

  getHeader() {
    const doc = this.getDocument();
    return doc.head;
  },

  updateConfig() {
    const width_close = 91;
    const height_close = 91;
    const padding = md.mobile() ? 0 : 0;
    if (this.conf.isTypeShow == 'facebook') {
      this.updateDim(height_close + 'px', height_close + 'px', 0, padding);
      return this;
    }
    if (!md.mobile()) {
      if (
        this.conf.chat_box_position == 7 ||
        this.conf.chat_box_position == 4
      ) {
        this.updateDim(
          width_close + 'px',
          height_close + 'px',
          padding,
          padding
        );
      } else if (
        this.conf.chat_box_position == 9 ||
        this.conf.chat_box_position == 6
      ) {
        this.updateDim(
          width_close + 'px',
          height_close + 'px',
          padding,
          null,
          padding
        );
      }
      // else if (this.conf.chat_box_position == 6) {
      //   this.updateDim(
      //     width_close + 'px',
      //     height_close + 'px',
      //     window.innerHeight / 2 - 30,
      //     null,
      //     padding
      //   );
      // } else if (this.conf.chat_box_position == 4) {
      //   this.updateDim(
      //     width_close + 'px',
      //     height_close + 'px',
      //     window.innerHeight / 2 - 30,
      //     padding
      //   );
      // }
      else {
        this.updateDim(
          width_close + 'px',
          height_close + 'px',
          padding,
          padding
        );
      }
      return;
    }

    if (this.conf.chat_box_position == 7 || this.conf.chat_box_position == 4) {
      this.updateDim(width_close + 'px', height_close + 'px', padding, padding);
    } else if (
      this.conf.chat_box_position == 9 ||
      this.conf.chat_box_position == 6
    ) {
      this.updateDim(
        width_close + 'px',
        height_close + 'px',
        padding,
        null,
        padding
      );
    }
    // else if (this.conf.chat_box_position == 6) {
    //   this.updateDim(
    //     width_close + 'px',
    //     height_close + 'px',
    //     window.innerHeight / 2 - 30,
    //     null,
    //     padding
    //   );
    // } else if (this.conf.chat_box_position == 4) {
    //   this.updateDim(
    //     width_close + 'px',
    //     height_close + 'px',
    //     window.innerHeight / 2 - 30,
    //     padding
    //   );
    // }
    else {
      this.updateDim(width_close + 'px', height_close + 'px', padding, padding);
    }
  },

  render() {
    this.$el.attr({ class: this.pfx + 'frame', id: this.pfx + 'frame' });
    this.$el.css({
      position: 'fixed',
      'z-index': 200000000,
      overflow: 'hidden',
      display: 'block'
    });
    return this;
  }
});
